import MODULES from "./module.constant";

export const getDefaultRedirect = (modules, role) => {

   //  if(modules && Array.isArray(modules) && modules.includes(MODULES.DASHBOARD)){
   //     return '/patient/'
   //  }

     return '/patient-details/'
}